import React from "react";
import { useObservable } from "micro-observables";

import { newDataSelector } from "../../../services/stepThree";
import DataSelectorList from "../components/DataSelectorList";

import SaveLinksDialog, { SAVE_LINK_INITIAL_VALUES } from "./SaveLinksDialog";
import useSelectorListActions from "./hooks/useSelectorListActions";
import useLinksNameDialog from "./hooks/useLinksNameDialog";

const CurrentDataSelector = () => {
    const newSelector = useObservable(newDataSelector);

    const {
        isLinksNameDialogOpen,
        handleLinksNameOpen,
        handleLinksNameClose
    } = useLinksNameDialog();

    const {
        handleDeleteDataSelector,
        handleSaveLinksDone
    } = useSelectorListActions({ onLinksNameClose: handleLinksNameClose });

    if(!newSelector) {
        return null;
    }

    return (
        <>
            <DataSelectorList
                dataSelectors={[ newSelector ]}
                onSaveSelectors={handleLinksNameOpen}
                onDeleteDataSelector={handleDeleteDataSelector}
            />

            <SaveLinksDialog
                isOpen={isLinksNameDialogOpen}
                initialValues={SAVE_LINK_INITIAL_VALUES}
                onSubmit={handleSaveLinksDone}
                onClose={handleLinksNameClose}
            />
        </>
    );
};

export default CurrentDataSelector;
